































import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import SchoolInput from '@/store/models/maintain/schoolInput'
@Component({})
export default class SchoolManager extends VueBase {
	loading: boolean = false
	finished: boolean = false
	error: boolean = false
	totalCount: number = 0
	schoolList: Array<any> = []
	searchForm: SchoolInput = new SchoolInput()
	schoolName: string = ''
	onClickLeft() {
		window.history.go(-1)
	}

	// 页面初次加载
	async onLoad() {
		this.error = false
		this.searchForm.page += 1
		if (this.totalCount !== 0 && this.schoolList.length === this.totalCount) return
		await this.searchSchoolList()
	}
	// 查询数据
	async searchSchoolList() {
		await ajax
			.get('/School/GetSchoolList', { params: this.searchForm })
			.then((rep) => {
				this.schoolList.push(...rep.data.result.items)
				this.totalCount = rep.data.result.total
				if (this.schoolList.length === this.totalCount) this.finished = true
			})
			.catch(() => {
				this.error = false
			})
			.finally(() => {
				this.loading = false
			})
	}

	async onSearch() {
		this.searchForm.schoolName = this.schoolName
		this.schoolList = []
		this.error = false
		this.searchForm.page = 1
		if (this.totalCount !== 0 && this.schoolList.length === this.totalCount) return
		await this.searchSchoolList()
	}
	onCancel() {

	}
}
